<template>
	<v-autocomplete
		dense
		:clearable="clearable"
		:hide-details="hideDetails"
		:error="errorBorder"
		:error-messages="$props.error"
		:items="options"
		:multiple="true"
		:readonly="readonly"
		item-text="label"
		item-value="value"
		outlined
		v-model="selectedValue"
		:label="label"
	>
		<template #prepend-item>
			<slot name="firstItem"></slot>
		</template>
		<template #prepend>
			<slot name="prepend"></slot>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	name: 'DropdownMultiple',
	props: {
		readonly: Boolean,
		value: Array,
		ajax: Boolean,
		data: [Array, String],
		label: String,
		clearable: {
			type: Boolean,
			default: false,
		},
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			endpoint: '',
			selectedValue: null,
			options: [],
			ajaxLoaded: false,
			protected: null,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != this.selectedValue) {
					this.protected = newVal;
					this.setValue(newVal);
				}
			}
		},
		selectedValue: function (val) {
			if (val != this.$props.value) {
				if (val != null) {
					if (val != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', val);
						});
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					});
				}
				this.$nextTick(() => {
					this.callChange();
				});
			}
		},
	},
	methods: {
		callChange() {
			this.$emit('changes');
		},
		setValue(newVal) {
			if (this.$props.ajax) {
				var vm = this;
				this.$APICall(
					'get',
					'select/' + this.endpoint,
					{ protected: this.protected },
					(data, success) => {
						if (success) {
							vm.options = data;
							vm.ajaxLoaded = true;
							vm.selectedValue = newVal;
						}
					},
					false
				);
			} else {
				this.options = this.$props.data;
				this.selectedValue = newVal;
			}
		},
	},
	mounted() {
		if (this.$props.ajax) {
			this.endpoint = this.$props.data;
		}
		this.protected = this.$props.value;
		this.setValue(this.$props.value);
	},
};
</script>

<style scoped></style>
